// extracted by mini-css-extract-plugin
module.exports = {"button":"ContentWithShowMore_button__3-Ihw","buttonLess":"ContentWithShowMore_buttonLess__55orI","dots":"ContentWithShowMore_dots__1eojI"};